<template>
  <el-dialog title="Thông báo" :visible.sync="localVisible" width="520px" :append-to-body="false">
    <div>Bài chấm đầu tiên của giảng viên có dấu hiệu chưa đạt yêu cầu.</div>
    <br />
    <div>Để phân loại lỗi chính xác, bạn cần thanh tra thêm bài tập tương ứng.</div>
    <div>Nhưng hiện tại không còn bài phù hợp, hệ thống sẽ mặc định là <strong>Lỗi sự vụ.</strong></div>
    <br />
    <div>Bạn có chắc chắn muốn lưu kết quả thanh tra này không?</div>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-light-gray font-weight-bold mr-2" :disabled="disabled" @click="onCancel">
        <i class="fas fa-times"></i> Đóng
      </button>
      <button class="btn btn-purple font-weight-bold mr-2" :disabled="disabled" @click="$emit('confirm')">
        <i v-if="!disabled" class="fas fa-check"></i>
        <i v-else class="fas fa-spinner fa-spin"></i>
        {{ disabled ? 'Đang lưu...' : 'Lưu kết quả' }}
      </button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'NoReplacementDialog',
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    }
  },
  methods: {
    onCancel() {
      this.$emit('update:visible', false);
      this.$emit('cancel');
    }
  }
}
</script>

<style scoped>
</style>


